import { useRef, useState } from 'react';

import AngleDownIcon from 'shared/components/AngleDownIcon';
import * as types from 'shared/components/NewNavbar/types';
import { Typography } from 'ui/shared/molecules/Typography/Typography';

import { LinkInExpandedMenuMobile } from '../LinkInExpandedMenuMobile/LinkInExpandedMenuMobile';
import styles from './ExpandableMenuItemMobile.module.scss';

export function ExpandableMenuItemMobile({ children, innerItems, title, closeMenu }: types.ExpandableMenuItemMobile) {
  const [expanded, setExpanded] = useState(false);
  const expandedCardRef = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.mobileExpandedWrapper} data-expandable-mobile="true" role="button" tabIndex={0}>
      <div
        className={styles.mobileExpandedWrapper}
        ref={expandedCardRef}
        onClick={() => setExpanded(!expanded)}
        role="button"
        tabIndex={0}
      >
        <Typography.Header color="#FFFFFF" size="md" tagType="div" gutterBottom={false}>
          {title}
        </Typography.Header>
        <div className={`${styles.expandedContent} ${expanded ? styles['expandedContent--open'] : ''}`}>
          {children}
          <ul onClick={closeMenu}>
            {innerItems?.map((item) => <LinkInExpandedMenuMobile item={item} key={item.id} />)}
          </ul>
        </div>
        {innerItems && (
          <AngleDownIcon className={`${styles.icon} ${expanded ? '' : styles['icon--rotated']}`} dark={false} />
        )}
      </div>
    </div>
  );
}
